import Vue from 'vue'
import App from './App'

// BootstrapVue add
import BootstrapVue from 'bootstrap-vue'
// Router & Store add
import router from './router'
import { store } from './store'
// Multi Language Add
import en from './locales/en.json'
import es from './locales/es.json'
import VueI18n from 'vue-i18n'
import { defaultLocale, localeOptions } from '@/constants/config' // firebaseConfig
// Notification Component Add
import Notifications from '@/components/Common/Notification'
// Breadcrumb Component Add
import Breadcrumb from '@/components/Common/Breadcrumb'
// RefreshButton Component Add
import RefreshButton from '@/components/Common/RefreshButton'
// Colxx Component Add
import Colxx from '@/components/Common/Colxx'
// Perfect Scrollbar Add
import vuePerfectScrollbar from 'vue-perfect-scrollbar'
import contentmenu from 'v-contextmenu'
import lineClamp from 'vue-line-clamp'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import VueScrollTo from 'vue-scrollto'
//import firebase from 'firebase/app'
//import 'firebase/auth'

import Element from 'element-ui'
// import "element-ui/lib/theme-chalk/index.css"
import VueCurrencyFilter from 'vue-currency-filter'
import VueCurrencyInput from 'vue-currency-input'
import ImageUploader from 'vue-image-upload-resize'

import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'

import Decimal from 'decimal.js'
import number2 from '@/components/Number/number2'
import Highcharts3D from 'highcharts/highcharts-3d'
import stockInit from 'highcharts/modules/stock'
import drilldown from 'highcharts/modules/drilldown'

import loadingBox from './components/custom/page_loader.vue'
import modalx from './components/custom/modal.vue'
import numberx from './components/custom/number2.vue'

import { LicenseManager } from 'ag-grid-enterprise'

/* License : AG Grid */
LicenseManager.setLicenseKey("CompanyName=Mango Consultant Company Limited,LicensedGroup=MANGO CONSULTANT COMPANY LIMITED,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-012819,ExpiryDate=11_January_2022_[v2]_MTY0MTg1OTIwMDAwMA==9cb9e9dbbb58c7885b88637b76cdafac")

const pluginOptions = { /* see config reference */ }
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(Element)
Vue.use(ImageUploader)
Vue.use(BootstrapVue)
Vue.use(VueI18n)

stockInit(Highcharts)

Highcharts3D(Highcharts)
// import InfiniteLoading from 'vue-infinite-loading';
drilldown(Highcharts)

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    resetZoom: 'Reset',
    thousandsSep: ','
  }
})

Vue.use(HighchartsVue, {
  highcharts: Highcharts
})

const messages = { en: en, es: es }
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages
})

Vue.use(Notifications)
Vue.component('piaf-breadcrumb', Breadcrumb)
Vue.component('b-refresh-button', RefreshButton)
Vue.component('b-colxx', Colxx)
Vue.component('vue-perfect-scrollbar', vuePerfectScrollbar)
Vue.component('number2', number2)
Vue.component('loading-box', loadingBox)
Vue.component('modalx', modalx)
Vue.component('numberx', numberx)

Vue.use(require('vue-shortkey'))
Vue.use(contentmenu)
Vue.use(lineClamp, { /* plugin options */ })
Vue.use(VCalendar, {
  firstDayOfWeek: 2, // ...other defaults,
  formats: {
    title: 'MMM YY',
    weekdays: 'WW',
    navMonths: 'MMMM',
    input: ['DD/MM/YYYY', 'DD/MM/YYYY'],
    // dayPopover: 'L'
  },
  datePickerShowDayPopover: false,
  popoverExpanded: true,
  popoverDirection: 'bottom'
})

Vue.use(VueScrollTo)

Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
  })

// firebase.initializeApp(firebaseConfig)

export default new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})
